enum CargoAddressListingFilterType {
  DESCRIPTION = "DESCRIPTION",
  COUNTRY = "COUNTRY",
  TOWN = "TOWN",
  ZIP_CODE = "ZIP_CODE",
  STREET = "STREET",
}

export default CargoAddressListingFilterType;
